// extracted by mini-css-extract-plugin
module.exports = {"truncateSingleLine":"text_truncateSingleLine__OwOK6","truncate":"text_truncate__UfxmE"};